import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../../Icon/Icon.es.js';

const SidenavItemInner = ({ name, children })=>{
    return jsxs("span", {
        className: "inner",
        children: [
            name && jsx(Icon, {
                className: "item-icon",
                name: name,
                size: 20
            }),
            jsx("span", {
                className: "label",
                children: children
            })
        ]
    });
};
SidenavItemInner.displayName = 'Sidenav.Item.Inner';

export { SidenavItemInner };
//# sourceMappingURL=Sidenav.Item.Inner.es.js.map
